// Product page: variant picker, price, photo and gallery thumbnails.
(function () {
  const root = document.querySelector("[data-product]");
  const dataEl = document.querySelector("[data-product-json]");
  if (!root || !dataEl) return;

  const product = JSON.parse(dataEl.textContent);
  const mainImg = document.getElementById("main-img");
  const idInput = document.querySelector("[data-variant-id]");
  const money = (cents) => (cents / 100).toLocaleString("fr-FR", { style: "currency", currency: "EUR" });

  function selectedOptions() {
    return product.options.map((_, i) => {
      const checked = document.querySelector(`input[data-option-index="${i}"]:checked`);
      return checked ? checked.value : null;
    });
  }

  function showImage(src) {
    if (!mainImg || !src) return;
    mainImg.src = src;
    mainImg.removeAttribute("srcset");
    document.querySelectorAll("[data-thumb]").forEach((b) => b.setAttribute("aria-pressed", String(b.dataset.thumb === src)));
  }

  function update() {
    const chosen = selectedOptions();
    const variant = product.variants.find((v) => v.options.every((o, i) => o === chosen[i]));
    chosen.forEach((value, i) => {
      const label = document.querySelector(`[data-option-label="${i}"]`);
      if (label) label.textContent = value;
    });
    if (!variant) return;

    idInput.value = variant.id;
    document.querySelectorAll("[data-price]").forEach((el) => (el.textContent = money(variant.price)));
    document.querySelectorAll("[data-add]").forEach((btn) => (btn.disabled = !variant.available));
    const label = document.querySelector("[data-add-label]");
    if (label) label.textContent = variant.available ? "Ajouter au panier" : "Épuisé";

    if (variant.featured_media) {
      const thumb = document.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
      if (thumb) showImage(thumb.dataset.thumb);
    }
    const url = new URL(location.href);
    url.searchParams.set("variant", variant.id);
    history.replaceState({}, "", url);
  }

  document.querySelectorAll("input[data-option-index]").forEach((input) => input.addEventListener("change", update));
  document.querySelectorAll("[data-thumb]").forEach((btn) => btn.addEventListener("click", () => showImage(btn.dataset.thumb)));
})();
